// @flow
import { WORKSPACE_KIND } from 'common/constants/workspaceKind';

const DISPLAY_WORKSPACE_KIND = {
  [WORKSPACE_KIND.general]: 'Backend',
  [WORKSPACE_KIND.frontend]: 'Frontend',
};

export const getDisplayWorkspaceKind = (kind: string) => DISPLAY_WORKSPACE_KIND[kind] || kind;
